module.exports = __webpack_public_path__ + "static/media/Artboard5.48c422fa.png";